let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("j2GwS"), load("e9stW"), load("ffEVr"), load("hDfPU")]).then(() => parcelRequire('2mD8T'));